<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <base-button type="secondary" size="sm" class="btn-secondary--alt" v-if=" units.length < 1 " v-on:click="loadDefaultUnits">Load Default Units</base-button>
          <router-link to="/unit/add-unit"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Unit</base-button></router-link>
          <router-link to="/ingredient/add-ingredient"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Ingredient</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <!--
      <form style="margin-top:60px">
        <input v-on:input="event => search(event)" type="text" />
      </form>
      -->
      <div>
        <card class="no-border-card mt-2 card-results" body-classes="px-0 pt-2 pb-1" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col cols="6" class="d-flex align-items-center flex-wrap" v-if="view === 'table'">
                <!-- <p class="mb-0 mr-2 text-sm" v-if="filterShow">{{ filterShow }}</p> -->

                <!-- <el-select class="select-primary pagination-select" v-model="pagination.perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select> -->

                <!-- <p class="mb-0 ml-2 text-sm" v-if="filterEntries">{{ filterEntries }}</p> -->
              </b-col>
            </b-row>
          </template>
          <div>
            <el-table :data="units"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Name" min-width="300px" prop="name" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <a :href="'/unit/edit-unit/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.image)?'avatar--grey':' rounded-circle'">
                      <b-img alt="Image placeholder" :src="row.logo.absoluteUri" v-if="row.logo"></b-img>
                      <span>{{ row.name ? row.name.charAt(0) : '' }}</span>
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/unit/edit-unit/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.name }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Long Name" min-width="300px" prop="longName" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/unit/edit-unit/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.longName }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Plural Name" min-width="300px" prop="pluralName" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/unit/edit-unit/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.pluralName }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>              
              
              
              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <b-dropdown-item @click.native="handleView($index, row)">View</b-dropdown-item>
                      <b-dropdown-item @click.native="handleEdit($index, row)">Edit</b-dropdown-item>
                      <b-dropdown-item>Share</b-dropdown-item>
                      <b-dropdown-item>Invite</b-dropdown-item>
                      <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <!-- <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p> -->
            </div>
            <!-- <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination> -->
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
// import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
import swal from 'sweetalert2';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      possibleUnits: [
        {
            "name": "C",
            "longName": "cup",
            "pluralName": "cups",
            "showWhenZero": false
        },
        {
            "name": "gal",
            "longName": "gallon",
            "pluralName": "gallons",
            "showWhenZero": false
        },
        {
            "name": "qt",
            "longName": "quart",
            "pluralName": "quarts",
            "showWhenZero": false
        },
        {
            "name": "L",
            "longName": "liter",
            "pluralName": "liters",
            "showWhenZero": false
        },
        {
            "name": "ml",
            "longName": "milliliter",
            "pluralName": "milliliters",
            "showWhenZero": false
        },
        {
            "name": "oz",
            "longName": "Ounce",
            "pluralName": "Ounces",
            "showWhenZero": true
        },
        {
            "name": "fl oz",
            "longName": "Fluid Ounce",
            "pluralName": "Fluid Ounces",
            "showWhenZero": true
        },
        {
            "name": "pt",
            "longName": "pint",
            "pluralName": "pints",
            "showWhenZero": false
        },
        {
            "name": "t",
            "longName": "teaspoon",
            "pluralName": "teaspoons",
            "showWhenZero": false
        },
        {
            "name": "T",
            "longName": "tablespoon",
            "pluralName": "tablespoons",
            "showWhenZero": false
        },
        {
            "name": "piece",
            "longName": "piece",
            "pluralName": "pieces",
            "showWhenZero": false
        },
        {
            "name": "dash",
            "longName": "dash",
            "pluralName": "dash",
            "showWhenZero": false
        },
        {
            "name": "drop",
            "longName": "drop",
            "pluralName": "drops",
            "showWhenZero": false
        },
        {
            "name": "pinch",
            "longName": "pinch",
            "pluralName": "pinches",
            "showWhenZero": false
        }
    ]
    };
  },
   computed: {
     units() {
      return Object.values(this.$store.state.units.all)
     }
  },
  methods: {
    dateFormat(date) {
      var local = new Date(date);
      return local.toJSON().slice(0,10);
    },
    // paginationChanged(page) {
    //   this.pagination.currentPage = page;
    // },
    handleView(index, row) {
        this.$root.$router.push({
            name: 'Unit',
            params: { id: row.id }
        });
    },
    handleEdit(index, row) {
        this.$root.$router.push({
            name: 'Edit Unit',
            params: { id: row.id }
        });
    },
    loadDefaultUnits() {

      for (const property in this.possibleUnits) {
          setTimeout(this.loadDefaultUnit, 150, this.possibleUnits[property])
        }
    },
    loadDefaultUnit(unit) {
      const { dispatch } = this.$store;
      try {
        setTimeout(function(){
          dispatch("units/addUnit", unit)
              .then(response => {
              this.$store.state.units.all.push(unit)
          }).catch(error => {
              console.log('Something went wrong: ', error);
          });
        }, 150)
      } catch (error) {
          console.log("Error: tag add", error);
      }
    },
    handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.title}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      const { dispatch } = this.$store;
      dispatch("units/deleteUnit",row.id)
      let indexToDelete = this.units.findIndex((tableRow) => tableRow.id === row.id);
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    toggleActive(event, view) {
      event.preventDefault();

      const button = event.target.closest('.btn-view');
      const card = document.querySelector('.card-results');

      button.classList.add('active')

      Array.prototype.filter.call(button.parentNode.children, function(child){
        if (child !== button) {
          child.classList.remove('active')
        }
      });

      this.view = view;

      this.view == 'grid'
        ? card.classList.add('card-results--alt')
        : card.classList.remove('card-results--alt')
    },
    loadUnit(event) {
      event.preventDefault();

      let route = 'unit';
      const button = event.target.closest('a');

      if (button) {
        this.$router.push({
          name: 'ViewUnit',
          params: {
            id: button.getAttribute('href')
          }
        }).catch(() => {});
      }
    },
    search(evt) {
      const { dispatch } = this.$store;
      dispatch("units/searchUnits",evt.target.value);
    }
  },
  created() {
    const { dispatch } = this.$store;
    dispatch("units/getAllUnits");
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
